import React from "react";
import labPhoto from '../assets/images/frontMainLogo.png';
import rtpcr1 from '../assets/images/rtpcr-amplification-1.png';
import rtpcr2 from '../assets/images/rtpcr-amplification-2.png';
import rtpcrRealtime from '../assets/images/rtpcr-realtime-machine.png';
import gradientThermalCycler from '../assets/images/gradient-thermal-cycler.png';
import ibrightImager from '../assets/images/ibright-imager.png';
import miniampGradientPcr from '../assets/images/miniamp-gradient-pcr.png';
import spectrophotometer from '../assets/images/spectrophotometer.png';
import '../assets/styles/Gallery.scss';

const photos = [
  {
    src: labPhoto,
    title: "Tissue Culture Bench",
    caption: "Researchers preparing plant tissue culture samples in the lab.",
  },
  {
    src: rtpcrRealtime,
    title: "Real-Time PCR (Bio-Rad CFX-96)",
    caption: "Our Real-Time PCR system used for qPCR, gene expression and diagnostic assays.",
  },
  {
    src: gradientThermalCycler,
    title: "Gradient Thermal Cycler (MJ Research)",
    caption: "Single-block thermal cycler for standard PCR amplification runs.",
  },
  {
    src: miniampGradientPcr,
    title: "MiniAmp Plus Gradient PCR (Applied Biosystems)",
    caption: "Gradient PCR system for optimizing primer annealing temperatures.",
  },
  {
    src: rtpcr1,
    title: "RT-PCR Amplification Curve",
    caption: "Real-time fluorescence readout across 40 amplification cycles.",
  },
  {
    src: rtpcr2,
    title: "RT-PCR Amplification Curve",
    caption: "qPCR run showing distinct sample threshold crossings.",
  },
  {
    src: ibrightImager,
    title: "iBright FL1000 Image Analyzer",
    caption: "Digital imaging system for documenting DNA/RNA gels and chemiluminescent blots.",
  },
  {
    src: spectrophotometer,
    title: "Spectrophotometer (Bio-Rad SmartSpec Plus)",
    caption: "Used to quantify DNA, RNA and protein concentration and purity.",
  },
];

function Gallery() {
  return (
    <div className="gallery-container" id="gallery">
      <h1>From the Lab</h1>
      <div className="gallery-grid">
        {photos.map((photo) => (
          <div className="gallery-item" key={photo.title + photo.src}>
            <img src={photo.src} alt={photo.title} />
            <h3>{photo.title}</h3>
            <p>{photo.caption}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Gallery;
